/**
 * @author:POPE
 * @date:2019-05-31
 * @description: 通用类
 */
 class Common {
    static getInstance () {
      if (!this.instance) this.instance = new Common()
      return this.instance
    }
    /**
     * @author:POPE
     * @date:2019-06-05
     * @description: 获取DPI
     */
    // eslint-disable-next-line
    conversion_getDPI () {
      let arrDPI = []
      if (window.screen.deviceXDPI) {
        arrDPI[0] = window.screen.deviceXDPI
        arrDPI[1] = window.screen.deviceYDPI
      } else {
        let tmpNode = document.createElement('DIV')
        tmpNode.style.cssText =
          'width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden'
        document.body.appendChild(tmpNode)
        arrDPI[0] = parseInt(tmpNode.offsetWidth)
        arrDPI[1] = parseInt(tmpNode.offsetHeight)
        tmpNode.parentNode.removeChild(tmpNode)
      }
      return arrDPI
    }
    /**
     * @author:POPE
     * @date:2019-06-05
     * @description: px转换为mm
     */
    tpxConversionMm (value) {
      let inch = value / this.conversion_getDPI()[0]
      let result = inch * 25.4
      return result
    }
    /**
     * @author:POPE
     * @date:2019-06-05
     * @description: mm转换为px
     */
    mmConversionPx (value) {
      let inch = value / 25.4
      let result = inch * this.conversion_getDPI()[0]
      return result
    }
    /**
     * @author:POPE
     * @date:2021-06-02
     * @description: 格式化菜单项
     */
     formatMenuList (data) {
      let root = process.env.VUE_APP_ROOT
      let NODE_ENV = process.env.NODE_ENV
      if (NODE_ENV !== 'development') root = ''
      list(data)
      function list (data) {
        for (let item of data) {
          let component = item.component || 'layout/Index.vue'
          item.path = item.path || item._url || '/'
          item.icon = item.icon || 'el-icon-folder'
          item.badge = item.badge || 0
          item.leaf = false
          if (item._type === 'iframe') {
            component = 'views/iframe/IframePage.vue'
            item._url = `${root}${item._url}`
          }
          item.component = resolve => require([`components/${component}`], resolve) // 懒加载方式，当路由被访问的时候才加载对应组件
          if (item.children) {
            list(item.children)
          }
        }
      }
      return data
    }
    /**
     * @author:POPE
     * @date:2019-06-05
     * @description: 格式化菜单项 -弃用
     */
    formatMenuList1 (data) {
      let result = []
      let root = process.env.VUE_APP_ROOT
      let NODE_ENV = process.env.NODE_ENV
      if (NODE_ENV !== 'development') root = ''
      for (let item of data) {
        item.path = item.path || '/'
        let component = item.component || 'layout/Index.vue'
        item.icon = item.icon || 'el-icon-folder'
        item.badge = item.badge || 0
        item.leaf = false
        item.component = resolve => require([`components/${component}`], resolve) // 懒加载方式，当路由被访问的时候才加载对应组件
        if (item.children) {
          for (let child of item.children) {
            child.path = child.path || child._url
            let componentChild = child.component
            if (child._type === 'iframe') {
              componentChild = 'views/iframe/IframePage.vue'
              child._url = `${root}${child._url}`
            }
            child.component = resolve => require([`components/${componentChild}`], resolve)
            child.icon = 'el-icon-s-order'
            child.badge = child.badge || 0
          }
        }
        result.push(item)
      }
      return result
    }
    /**
     * @description: 生成GUID（全球唯一标识）
     * @param {type}
     * @return:
     */
    newGuid () {
      let guid = ''
      for (let i = 1; i <= 32; i++) {
        let n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
        if (i === 8 || i === 12 || i === 16 || i === 20) guid += '-'
      }
      return guid
    }
    randomn (n) {
      if (n > 21) return null
      return parseInt((Math.random() + 1) * Math.pow(10, n - 1))
    }
    /**
     * @description: 获取随机icon
     * @param {type}
     * @return:
     */
    getRandomIcon () {
      let icons = [
        'el-icon-star-off',
        'el-icon-goods',
        'el-icon-picture-outline',
        'el-icon-folder',
        'el-icon-folder-add',
        'el-icon-folder-checked',
        'el-icon-brush',
        'el-icon-reading',
        'el-icon-coordinate',
        'el-icon-coin',
        'el-icon-wallet',
        'el-icon-link',
        'el-icon-set-up',
        'el-icon-position',
        'el-icon-copy-document',
        'el-icon-map-location'
      ]
      let icon = icons[Math.floor(Math.random() * icons.length)]
      return icon
    }
    /**
     * @description: 对象转url参数
     * @param {type}
     * @return:
     */
    queryParams (data, prefix = '?') {
      let _result = []
      for (let key in data) {
        let value = data[key]
        if (value && value.constructor === Array) {
          value.forEach(function (_value) {
            value = encodeURIComponent(value)
            _result.push(key + '[]' + '=' + _value)
          })
          /*
          if (value.length === 0) {
            value = encodeURIComponent(value)
            _result.push(key + '=' + '[]')
          }
          */
        } else {
          value = encodeURIComponent(value)
          _result.push(key + '=' + value)
        }
      }
      return `${prefix}${_result.join('&')}`
    }
    /**
     * @description: 获取本地url上参数
     * @param {type}
     * @return:
     */
    getQueryString (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      let r = window.location.search.substr(1).match(reg)
      if (r != null) return decodeURIComponent(r[2])
      return null
    }
    /**
    * @description: 获取本地url上参数,返回对象
    * @param {type}
    * @return:
    */
    getURLParameter () {
      // debugger
      let paramObj = {}
      let url = window.location.href
      if (url.includes('?')) {
        let urlParams = url.split("?")[1];//或者url获取参数字符串
        let paramArray = urlParams.split("&");
        let len = paramArray.length;
        let arr = [];//数组对象
        for (let i = 0; i < len; i++) {
          arr = paramArray[i].split("=");
          paramObj[arr[0]] = decodeURIComponent(arr[1])
        }
      }
      return paramObj
    }
    /**
     * @author: POPE
     * @description: 数字转成百分比
     * @param {type}
     * @return:
     */
    toPercent (val) {
      return (Math.round(val * 10000) / 100).toFixed(2) + '%'
    }
    /**
     * @description: 导出文件
     * @param {type}
     * @return:
     */
    exportFile (url, param) {
      let NODE_ENV = process.env.NODE_ENV
      let root = ``
      if (NODE_ENV === 'development') root = process.env.VUE_APP_ROOT
      let src = `${root}${url}${this.queryParams(param)}`
      window.open(src, '_self')
    }
    /**
     * @author: POPE
     * @description: 下载文件
     * @return:
     * @param id
     */
    downloadFile (id) {
      let NODE_ENV = process.env.NODE_ENV
      let host = process.env.VUE_APP_ROOT
      if (NODE_ENV !== 'development') host = ''
      let url = `${host}/base/file/download?fileId=${id}&token=${
        JSON.parse(sessionStorage.getItem('user_info')).token
        }`
      window.open(url)
    }
    /**
     * @author: POPE
     * @description: element表格合并规则
     * @param {type}
     * @return:
     */
    spanRules (fields, data) {
      let rules = []
      let contactDot = 0
      if (data && data.length > 0) {
        data.forEach((item, index) => {
          if (index === 0) {
            rules.push(1)
          } else {
            let preItem = data[index - 1] // 前一行
            if (fields.length === 1) { // 不存在父合并约束
              if (item[fields[0]] === preItem[fields[0]]) {
                rules[contactDot] += 1
                rules.push(0)
              } else {
                contactDot = index
                rules.push(1)
              }
            }
            else if (fields.length > 1) { // 存在父合并约束
              if (item[fields[0]] === preItem[fields[0]] && item[fields[1]] === preItem[fields[1]]) {
                rules[contactDot] += 1
                rules.push(0)
              } else {
                contactDot = index
                rules.push(1)
              }
            }
          }
        })
      }
      return rules
    }
    /**
     * @author: POPE
     * @description: 删除表格行数据
     * @param {type}
     * @return:
     */
    deleteRow (data, index) {
      if (data && data.length > 0) {
        data.splice(index, 1)
      }
    }
    /**
     * @description 判断对象是否为空
     * @param {String} obj
     */
    isEmpty = obj => Object.keys(obj).length === 0 && obj.constructor === Object
    omit = (obj, props, fn) => {
        if (!Object.prototype.toString.call(obj) == '[object Object]') return {};

        if (typeof props === 'function') {
            fn = props;
            props = [];
        }

        if (typeof props === 'string') {
            props = [props];
        }

        var isFunction = typeof fn === 'function';
        var keys = Object.keys(obj);
        var res = {};

        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var val = obj[key];

            if (
                !props ||
                (props.indexOf(key) === -1 && (!isFunction || fn(val, key, obj)))
            ) {
                res[key] = val;
            }
        }
        return res;
    };
    debounce(fn, delay) {
      let timer
      return function() {
        const context = this
        const args = arguments // 存一下传入的参数
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(function() {
          fn.apply(context, args)
        }, delay)
      }
    }
    throttle(fn,delay){
      //首先设定一个变量，在没有执行我们的定时器时为null
      let timer = null;
      return function(){
        //当我们发现这个定时器存在时，则表示定时器已经在运行中，需要返回
        if(timer) return;
        timer = setTimeout(()=>{
          fn.apply(this,arguments);
          timer = null;
        },delay);
      }
    }
    typeOf = (obj) =>{
        const toString = Object.prototype.toString;
        const map = {
            '[object Boolean]': 'boolean',
            '[object Number]': 'number',
            '[object String]': 'string',
            '[object Function]': 'function',
            '[object Array]': 'array',
            '[object Date]': 'date',
            '[object RegExp]': 'regExp',
            '[object Undefined]': 'undefined',
            '[object Null]': 'null',
            '[object Object]': 'object'
        };
        return map[toString.call(obj)];
    }
    groupBy (collection, predicate) {
        var grouped = {};
        collection.forEach((item, idx) => {
            let groupKey = predicate(item, idx);
            if (typeof grouped[groupKey] === 'undefined') {
                grouped[groupKey] = [];
            }
            grouped[groupKey].push(item);
        });
        return grouped;
    }
    inputHandle (value, {
      min = 0,
      max = 10000,
      precision = 2,
    }) {
      if (value !== '') {
        var str = value.toString();
        var match = str.match(/\d+\.?\d*/);
        if (!match) {
          value = '';
        } else {
          var valid = match[0];
          var deci = valid.split('.');
          if (deci.length > 1 && deci[1].length > precision) {
            value = parseFloat(valid).toFixed(precision);
          } else {
            value = valid;
          }
        }
      }
      var newValue = value;
      if (newValue < min) {
        newValue = min;
      } else if (newValue > max) {
        newValue = max;
      }
      return newValue;
    }
    unique(arr, key) {
      const res = new Map();
      return arr.filter((item) => !res.has(item[key]) && res.set(item[key], 1));
    }

    /**
     * @author: POPE
     * @description: 获取cookie
     * @param {type}
     * @return:
     */
    getCookie (name) {
      let allcookies = document.cookie;
      let value = ''
      //索引长度，开始索引的位置
      let cookie_pos = allcookies.indexOf(name);
      // 如果找到了索引，就代表cookie存在,否则不存在
      if (cookie_pos != -1) {
        // 把cookie_pos放在值的开始，只要给值加1即可
        //计算取cookie值得开始索引，加的1为“=”
        cookie_pos = cookie_pos + name.length + 1;
        //计算取cookie值得结束索引
        let cookie_end = allcookies.indexOf(";", cookie_pos);
        if (cookie_end == -1) {
          cookie_end = allcookies.length;
        }
        //得到想要的cookie的值
        value = unescape(allcookies.substring(cookie_pos, cookie_end));
      }
      return value;
    }
  }
  export { Common }
